export class Files {
    filePath?: string;
    delete?: boolean;
    download?: boolean;
    upload?: boolean;
    selection?: boolean;
    more?: boolean;
    arrSelected?: Array<any>; // File name list

    constructor(file?: Files) {
        this.filePath = file.filePath ? file.filePath : null;
        this.delete = file.delete !== undefined ? file.delete : true;
        this.download = file.download !== undefined ? file.download : true;
        this.selection = file.selection !== undefined ? file.selection : false;
        this.upload =  file.upload !== undefined ? file.upload : true;
        this.more =  file.more !== undefined ? file.more : false;

        this.arrSelected = file.arrSelected !== undefined ? file.arrSelected : [];
    }
}
